import styled from 'styled-components';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px',
  backgroundColor: 'transparent',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'background .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#fdfbfd'
};

const FileUploaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #edebed;
  border-radius: 0;
  border-bottom-left-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .drag-wrapper {
    height: inherit;
    width: inherit;

    .drag-div {
      height: -webkit-fill-available;
      width: -webkit-fill-available;

      * {
        font-family: 'Montserrat Medium';
        color: var(--grey-50, #797E86);
      }

      .drag-text {
        font-size: 21px;
      }
    }
  }

  .cancel-btn {
    position: absolute;
    bottom: 25px;
    margin: 0 auto;

    border-radius: 10px;
    background: var(--grey-5, #F2F2F3);
    border-color: var(--grey-5, #F2F2F3);
    color:var(--blue-50, #0095FF);
    box-shadow:none;


    &:hover{
      background: var(--grey-10, #E4E5E7);
      border-color: var(--grey-10, #E4E5E7);
    }
    &:active{
      background: var(--Grey-20, #C9CBCF);
      border-color: var(--Grey-20, #C9CBCF);
    }

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export { baseStyle, activeStyle, FileUploaderWrapper };
